<template>

  <v-layout row wrap justify-center>

    <v-flex xs12 sm7 md4>
      <!-- Lista de botones -->
      <ul class="acron-bots" :class="{'ordered':ordered, 'bold':bold}">
        <li v-for="(bot, index) in bots" :class="bot.visto?'bullet-dav-ok-2':''" :key="index">
          <button :id="'bot-slide-'+index" @click="botClick(index+1, bot)" class=" animated flipInY" :class="'dura_'+index">
            <p class="acron-bots-text hvr-grow" v-html="bot.nameDesing"></p>
          </button>
        </li>
      </ul>
    </v-flex>
    <v-flex xs12 sm5 md6 class="aligner">
      <div tabindex="0" id="contenidos" :aria-label="'Contenido ' + bots[nombreCurrentBot].name" class="unstyled-focus"></div><br>
      <div tabindex="0" v-for="(item, index) in bots" :key="'slide-cont'+index" v-if="contenido === (index+1)">
        <slot :name="'cont-'+index"></slot>
      </div>
      <button v-if="!finContenidos" @click="backMenu()" aria-label="Volver a la lista anterior"></button>
    </v-flex>

  </v-layout>
</template>
<script>
export default {
  props: {
    bots: {
      type: Array,
      requiere: true
    },
    ordered:{
      type: Boolean,
      default: false,
      required: false
    },
    bold:{
      type: Boolean,
      default: false,
      required: false
    }
  },
  data() {
    return {
      finContenidos: false,
      contenido: 0,
      nombreCurrentBot: 0
    };
  },
  methods: {
    botClick(event, arr) {
      arr.visto = true;
      this.nombreCurrentBot = event - 1;
      this.contenido = event;
      document.getElementById("contenidos").focus();

      var showNext = this.bots.every(elem => {
        return elem.visto === true;
      });
      if (showNext) {
        this.$store.commit("nextShow", true);
      }
      this.finContenidos = showNext;
    },
    backMenu() {
      document.getElementById("bot-slide-" + this.contenido).focus();
    }
  }
};
</script>
<style lang="scss" scoped>
@import "../../sass/helpers/variables";
@import "../../sass/helpers/mixins";

.acron-bots {
  font-size: 1.6rem;
  text-align: left;
  &.ordered{
    list-style-type: decimal;
  }
  &.bold{
    font-weight: bold;
  }
  li.bullet-dav-ok-2 {
    list-style-image: url("../../assets/logos-icons/bullet-dav-ok-red.png");
  }
  .acron-bots-text {
    margin: 0;
  }
}
</style>



// WEBPACK FOOTER //
// BotsAcronimo.vue?5aabd0f8